import React from "react";
import "../../App.css";
 export default function CellLabel(props){
    const {title,value,labelWidth=100,style} = props;
    return ( <div className="cell-warp" style={style}>
        <div className="cell-label" style={{width:`${labelWidth}px`}}>{title}</div>
        <div className="cell-value"  dangerouslySetInnerHTML={{ __html: value }}></div>
    </div>)
 }